<template>
  <v-container id="slider-portada" class="pa-0" >


    <carrousel-slider v-if="legacy" :seccion="legacy.slider"></carrousel-slider>


    <seccion-top5 v-if="legacy" :seccion="legacy.tres"></seccion-top5>

    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 pr-0">
      <jmdb-template v-if="legacy" :seccion="legacy.uno"></jmdb-template>
      <jmdb-cuatro v-if="legacy" :seccion="legacy.dos"></jmdb-cuatro>
    </div>
    <div class="jumbotron no_space">
      <div class="jumbotron no_space dmbs-container">
        <jmdb-cuatro v-for="actual in bodyLayout" :key="actual" :seccion="actual"></jmdb-cuatro>
      </div>
    </div>
  </v-container>
</template>

<style>
.v-responsive.v-image.imagen-ficha {
  padding: 5px;
  background: white;
  border-radius: 5px;
  border: 3px solid white;
}

.imagen-ficha .v-image__image.v-image__image--cover {
  border: 3px solid white;
}
.transparente {
  background: transparent;
}
</style>

<script>
import CarrouselSlider from "@/components/Carrousel.vue";
import seccionTop5 from "@/components/plantilla/Top5.vue";
import jmdbTemplate from "@/components/plantilla/Destacados.vue";
import jmdbCuatro from "@/components/plantilla/Cuatro.vue";


export default {
  mouted() {
 // console.log("montado ", this.$store.state.layout);
    // this.onResize();
  },
  components: {
    seccionTop5,
    jmdbTemplate,
    jmdbCuatro,
    CarrouselSlider,
  },
  computed: {
    layout() {
      // console.log("slider", this.$store.state.layout);
      return this.$store.state.layout.pageLayout;
    },
    bodyLayout() {
      return this.$store.state.layout.pageLayout.filter(e=>e!=this.sliderSeccion).slice(3);
    },
    seccion() {
      return this.$store.state.layout.secciones;
    },
    legacy() {
      if (!this.layout && this.layout.length < 3) {
        return false;
      }

      const legacy = {
        tres: this.layout[2],
        uno: this.layout[0],
        dos: this.layout[1],
        slider: this.sliderSeccion
      };
      return legacy;
    },
  },
  data() {
    return {
      sliderVisible: true,
      sliderSeccion: 'svl1ph'
    };
  },
  methods: {},
};
</script>
